import React, {FC} from 'react';

import {RecipientRolesEnum} from '../../../../../libs/shared/core/src/models/api/recipientModel';
import {CellDraft} from '../content/cell/cellDraft';
import {renderCellSubject} from '../content/cell/cellMiddle';
import {CellRecipients} from '../content/cell/cellRecipients';
import {CompactCellActivity} from '../content/cell/compactCellActivity';
import {MessageCellCommonProps} from '../messageCellCommon';
import {CompactCellComponents} from './compactCellContentCommon';

/*
 * Props.
 */

interface CompactMessageCellContentProps extends MessageCellCommonProps {
  teammateId: number;
  isInDraftsFolder: boolean;
}

/*
 * Component.
 */

export const CompactMessageCellContent: FC<CompactMessageCellContentProps> = (props) => {
  const {
    recipients,
    isSelected,
    message,
    draft,
    conversationSubject,
    externalChannelType,
    applicationChannelType,
  } = props;
  const receivingRecipients = recipients.filter((r) => r.role !== RecipientRolesEnum.FROM);
  const recipient = recipients.find((r) => r.role === RecipientRolesEnum.TO);
  const hasAttachments = message.attachments.length > 0;
  const shouldShowAttachments = hasAttachments;
  return (
    <>
      <CompactCellComponents.FirstThird>
        <CompactCellComponents.Recipient>
          <CellRecipients recipients={receivingRecipients} isSelected={isSelected} />
        </CompactCellComponents.Recipient>
      </CompactCellComponents.FirstThird>
      <CompactCellComponents.MiddleThird $hasTags={false}>
        <CompactCellComponents.ContentWrapper>
          {draft && (
            <CompactCellComponents.CellDraftWrapper>
              <CellDraft
                isInDraftsFolder={false}
                draft={draft}
                isSelected={isSelected}
                conversationId={message.conversationId}
              />
            </CompactCellComponents.CellDraftWrapper>
          )}
          <CompactCellComponents.SubjectWrapper>
            {renderCellSubject({
              messageType: message.type,
              subject: message.subject || conversationSubject || '',
              subjectHighlight: undefined,
              recipient,
              isSelected,
              externalChannelType,
              applicationChannelType,
              isCompact: true,
              channelTypes: props.channelTypes,
            })}
          </CompactCellComponents.SubjectWrapper>
          <CompactCellActivity
            conversationId={message.conversationId}
            summary={message.blurb}
            isSelected={isSelected}
            lastCommentDraft={props.draftComment}
            lastComment={undefined}
            lastManualMessage={undefined}
            commentDraftSummary={undefined}
            draft={props.draft}
            isInDraftsFolder={props.isInDraftsFolder}
            teammateId={props.teammateId}
          />
        </CompactCellComponents.ContentWrapper>
      </CompactCellComponents.MiddleThird>
      <CompactCellComponents.LastThird>
        {shouldShowAttachments && <CompactCellComponents.AttachmentRightIcon isSelected={isSelected} />}
        <CompactCellComponents.CellDate
          isCompact
          date={props.date}
          reminderDate={props.reminderDate}
          slaTimerDate={undefined}
          waitingSinceMs={0}
          isSelected={isSelected}
        />
      </CompactCellComponents.LastThird>
    </>
  );
};
